import { useContext } from 'react';
import { Redirect } from 'react-router';
import { AuthenticationContext } from '../msal/AuthenticationContext';
import { AuthorizationContext } from '../context/AuthorizationContext';
import { TenantContext } from '../context/TenantContext';
import { urls } from '../logic/urls';
import { LoginScreen } from '../components/LoginScreen';

export const Home = () => {
    const authenticationContext = useContext(AuthenticationContext);
    const authorizationContext = useContext(AuthorizationContext);
    const tenantContext = useContext(TenantContext);

    if (authenticationContext.isAuthenticated()) {
        // If tenants have loaded but the list is empty, redirect to create a tenant
        if (tenantContext.hasLoadedTenants && tenantContext.availableTenants.length === 0) {
            return <Redirect to={urls.createTenant} />;
        }

        if (authorizationContext.isAuthorized()) {
            return <Redirect to={urls.license} />;
        }
    }

    return (
        <LoginScreen/>
    );
};